import React from 'react';
import CategoryInsights from './CategoryInsights';

const WhitePapers = () => {
  return (
    <CategoryInsights
      category="white-papers"
      titleKey="pages.whitePapers.title"
      subtitleKey="pages.whitePapers.subtitle"
      categoryLabelKey="insights.whitePapers"
    />
  );
};

export default WhitePapers;
